package com.exura.features.newauth.usecase

import com.exura.features.newauth.data.repository.ProviderFirebaseAuthRepository
import com.exura.features.newauth.domain.model.ProviderAuthUser
import com.exura.features.newauth.domain.model.ProviderUserRole
import dev.gitlive.firebase.functions.FirebaseFunctions
import kotlin.random.Random

class RandomRegisterProviderUseCase(
    private val authRepository: ProviderFirebaseAuthRepository,
    private val functions: FirebaseFunctions,
) {
    val REGISTER_PROVIDER_FUNCTION = "registerProvider2"
    private fun generateRandomPassword(length: Int = 12): String {
        val charPool = ('a'..'z') + ('A'..'Z') + ('0'..'9') + "!@#$%^&*()_+"
        return (1..length)
            .map { Random.nextInt(0, charPool.size) }
            .map(charPool::get)
            .joinToString("")
    }

    suspend operator fun invoke(
        email: String,
        role: ProviderUserRole,
    ): Result<ProviderAuthUser> = runCatching {
        val password = generateRandomPassword()
        val registerCallable = functions.httpsCallable(REGISTER_PROVIDER_FUNCTION)

        authRepository.register(email, password)

        val res = registerCallable.invoke(mapOf(
            "userRole" to role.name,
        ))
        val tok = res.data<String>()

        authRepository.logout()
        val resultUser = authRepository.signInToken(tok)

        resultUser.getOrThrow()
    }
}
